import { render, staticRenderFns } from "./CieloRadio.vue?vue&type=template&id=0345b788&scoped=true"
import script from "./CieloRadio.vue?vue&type=script&lang=js"
export * from "./CieloRadio.vue?vue&type=script&lang=js"
import style0 from "./CieloRadio.vue?vue&type=style&index=0&id=0345b788&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0345b788",
  null
  
)

export default component.exports